import React from 'react'
import classNames from 'classnames'
import { Label } from '@/components/ui/label'

const Form = {
    Group: ({ classname, className, children, controlId }) => (
        <div className={classNames('mb-4', className || classname)} id={controlId}>{children}</div>
    ),
    Label: ({ className, children, ...props }) => (
        <Label className={classNames('block mb-1', className)} {...props}>{children}</Label>
    ),
    Control: (props) => {
        if (props && props.as === 'select') {
            const { as, className, ...rest } = props
            return <select className={classNames('w-full form-control', className)} {...rest} />
        }
        const { className, ...rest } = props
        return <input {...rest} className={classNames('w-full form-control', className)} />
    },
    Check: ({ label, id, ...props }) => (
        <div className='flex items-center gap-2'>
            <input type='checkbox' id={id} {...props} />
            {label && <label htmlFor={id}>{label}</label>}
        </div>
    ),
    Text: ({ className, children, ...props }) => (
        <span className={classNames('block mb-1 text-sm text-muted-foreground', className)} {...props}>{children}</span>
    ),
}

export default Form
